const mutations = {
  SET_KEYWORD(state, keyword) {
    state.keyword = keyword
  },
  SET_ADVERTISER_ID(state, advertiserId) {
    state.advertiserId = Number(advertiserId)
  },
  SET_PAGE_NO(state, pageNo) {
    state.pageNo = Number(pageNo)
  },
  SET_MAP_REPORT(state, mapReport) {
    state.mapReport = mapReport
  },
  SET_LOADING_MAP_REPORT(state, loading) {
    state.loading = loading
  },
  RESET(state) {
    state.mapReport = {}
    state.keyword = ''
    state.advertiserId = 0
    state.pageNo = 1
  },
}

export default mutations
